export const TYPES = {
    GET_USER_DATA : "GET_USER_DATA",
    GET_USER_DATA_LOADING : "GET_USER_DATA_LOADING",
    GET_USER_DATA_FAILED : "GET_USER_DATA_FAILED",
}
